
  <ng-content select="[quill-editor-toolbar]"></ng-content>
